import { useMemo } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { ALL_BODY_IDS } from "@solar/ephemeris";
import { reducedMotion, useScene } from "../store";
import { bodyLive } from "./bodyState";
import { frame } from "./frame";
import { computeWorlds, displayRadius } from "./sceneData";

/**
 * 每帧最先运行（在 JSX 里排第一）：推进模式插值，计算所有天体的绝对显示坐标与显示半径。
 * 相机控制器随后据此确定浮动原点；各天体/轨道再把“绝对 − 原点”提交给 GPU。
 */
export function FrameUpdater() {
  const worlds = useMemo(() => new Map<(typeof ALL_BODY_IDS)[number], THREE.Vector3>(), []);
  useFrame((_, dt) => {
    const s = useScene.getState();
    const target = s.mode === "real" ? 1 : 0;
    frame.m += (target - frame.m) * (1 - Math.exp(-Math.min(dt, 0.1) * (reducedMotion ? 80 : 3.2)));
    if (Math.abs(target - frame.m) < 0.0005) frame.m = target;
    computeWorlds(new Date(s.timeMs), frame.m, worlds, ALL_BODY_IDS);
    for (const id of ALL_BODY_IDS) {
      const live = bodyLive.get(id), w = worlds.get(id);
      if (!live || !w) continue;
      live.world.copy(w);
      live.radius = displayRadius(id, frame.m);
    }
  });
  return null;
}
